import { useState, useEffect } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { API, LOCAL_APP_VERSION } from "@/config/constants";

const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes

export default function UpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Bypass service worker cache with cache-busting param
        const res = await axios.get(`${API}/version`, {
          params: { _t: Date.now() },
          headers: { 'Cache-Control': 'no-cache' }
        });
        if (res.data.version && res.data.version !== LOCAL_APP_VERSION) {
          setUpdateAvailable(true);
        }
      } catch {
        // Silently fail — don't bother user if offline
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    // Clear all service worker caches, then reload
    if ('caches' in window) {
      caches.keys().then(names => {
        Promise.all(names.map(name => caches.delete(name))).then(() => {
          window.location.reload();
        });
      });
    } else {
      window.location.reload();
    }
  };

  if (!updateAvailable) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] bg-primary text-primary-foreground px-4 py-2 flex items-center justify-center gap-3 text-sm shadow-lg cursor-pointer"
      onClick={handleUpdate}
      data-testid="update-banner"
    >
      <RefreshCw className="w-4 h-4 animate-spin" />
      <span>Update available — tap to refresh</span>
    </div>
  );
}
